import React, { useEffect, useRef, useState } from "react";
//import animationData from "../../../src/static/animations/join_meeting.json";
import WaitingToJoinAnimation from "./LoadingAni.json";
import Lottie from "lottie-react";
// import useIsTab from "views/live_class/Video_Sdk/hooks/useIsTab.js";
// import useIsMobile from "views/live_class/Video_Sdk/hooks/useIsMobile.js";


const WaitingToJoinScreen = () => {  
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: WaitingToJoinAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  const waitingMessages = [
    { index: 0, text: "Rolling out the chalkboard…" },
    { index: 1, text: "Rolling out the chalkboard…" },
  ];
  const [message, setMessage] = useState(waitingMessages[0]);

  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setMessage((s) =>
        s.index === waitingMessages.length - 1
          ? s
          : waitingMessages[s.index + 1]
      );
    }, 3000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  // const isTab = useIsTab();
  // const isMobile = useIsMobile();

  // const animationDefaultOptions = {
  //   loop: true,
  //   autoplay: true,
  //   animationData: animationData,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice",
  //   },
  // };

  return (
    // <div
    //   className="bg-gray-800"
    //   style={{
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     height: "100vh",
    //   }}
    // >
    //   <div className="flex flex-col">
    //     <div
    //       style={{
    //         height: isTab ? 200 : isMobile ? 200 : 250,
    //         width: isTab ? 200 : isMobile ? 200 : 250,
    //       }}
    //     >
         
    //     </div>
    //     <h1 className="text-white text-center font-bold mt-1 text-xl">
    //       {message.text}
    //     </h1>
    //   </div>
    // </div>
    <div className="WaitingToJoinScreen">
      <div className="LottiAnimation">      
        <Lottie options={defaultOptions} />
      </div>
      <div className="AnimationText">{message.text}</div>
    </div>
  );
};

export default WaitingToJoinScreen;
